import { get, create, update, deleteResource, updatePatch } from "./apiService";

export const getSupportedCurrencies = async () => {
  try {
    const supportedCurrencies = await get("/api/v1/currencies/get-all");
    const currencies = supportedCurrencies.data.data;
    return currencies;
  } catch (err) {
    //throw new Error(err.message);
  }
};
export const getFaq = async (cat) => {
  try {
    const faq = await get(`/api/v1/support-faqs/index?category=${cat}`);
    const allFaq = faq.data.data;

    return allFaq;
  } catch (err) {
    //throw new Error(err.message);
  }
};

export const getFaqCategories = async () => {
  try {
    const response = await get("/api/v2/faq/categories", {
      includeSubCategory: true,
    });
    if (response?.data?.status && response?.data?.data?.categories) {
      return response.data.data.categories;
    }
    return [];
  } catch (err) {
    return [];
  }
};

export const getFaqs = async (categoryId, subCategoryId = null) => {
  try {
    const params = {};
    if (categoryId) params.category = categoryId;
    if (subCategoryId) params.subCategory = subCategoryId;
    const query =
      Object.keys(params).length > 0
        ? "?" + new URLSearchParams(params).toString()
        : "";
    const response = await get(`/api/v2/faqs${query}`);
    if (response?.data?.status && Array.isArray(response?.data?.data)) {
      return response.data.data;
    }
    return [];
  } catch (err) {
    return [];
  }
};

export const searchFaq = async (q, options = {}) => {
  try {
    const { category, limit = 10, offset = 0 } = options;
    const params = { q: q.trim().slice(0, 500), limit, offset };
    if (category) params.category = category;
    const queryString = "?" + new URLSearchParams(params).toString();
    const response = await get(`/api/v2/faq/search${queryString}`);
    const ok =
      response?.data?.success === true &&
      response?.data?.data &&
      Array.isArray(response.data.data.results);
    if (ok) {
      return response.data.data;
    }
    return { query: q, results: [], total: 0, limit, offset, hasMore: false };
  } catch (err) {
    return {
      query: q,
      results: [],
      total: 0,
      limit: options.limit ?? 10,
      offset: options.offset ?? 0,
      hasMore: false,
    };
  }
};
export const setAccount = async (userId, accountId) => {
  try {
    const update = updatePatch(
      `/api/v1/sub-accounts/set-account/${userId}/${accountId}`
    );
    return update;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateAccount = async (userId, accountId, name) => {
  try {
    const update = updatePatch(
      `/api/v1/sub-accounts/update-name/${userId}/${accountId}`,
      {},
      { accountName: name }
    );
    return update;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const transferFunds = async (data) => {
  try {
    const transfer = create("/api/v1/sub-accounts/transfer-funds/", data);
    return transfer;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const setTimeframeCall = async (data, authId) => {
  try {
    const url = authId
      ? `/api/v1/settings/set-timeframe?authId=${authId}`
      : "/api/v1/settings/set-timeframe";
    const result = await create(url, {
      timeframe: data,
    });
    return result;
  } catch (err) {
    console.error("setTimeframeCall error:", err);
    throw err;
  }
};
export const createSubAccount = async (data) => {
  try {
    const result = await create("/api/v1/sub-accounts/create", data);
    if (!result) {
      throw new Error("Could not update time frame");
    }
    return result;
  } catch (err) {
    throw new Error(`Could not update time frame: ${err.message}`);
  }
};

export const setPrefCurrency = async (data, authId) => {
  try {
    const url = authId
      ? `/api/v1/settings/set-currency?authId=${authId}`
      : "/api/v1/settings/set-currency";
    const result = await create(url, {
      localCurrency: data,
    });
    return result;
  } catch (err) {
    console.error("setPrefCurrency error:", err);
    throw err;
  }
};

export const setAntiFish = async (data) => {
  try {
    const result = await create("/api/v1/settings/set-aphishing-code", {
      antiPhishCode: data,
    });
    if (!result) {
      throw new Error("Could not update AntiPhishing");
    }
    return result;
  } catch (err) {
    throw new Error(`Could not update AntiPhishing: ${err.message}`);
  }
};

export const setNotifChange = async (data) => {
  try {
    const result = await create("/api/v1/settings/set-notifications", {
      type: data.type,
      state: data.state,
    });
    if (!result) {
      throw new Error("Could not update Notification Change");
    }
    return result;
  } catch (err) {
    throw new Error(`Could not update Notification Change: ${err.message}`);
  }
};

export const unsubscribeEmail = async (userId) => {
  try {
    const result = await updatePatch(
      `/api/v1/settings/email-unsubscribe/`,
      { userId },
      {},
      {}
    );
    if (!result) {
      throw new Error("Could not update Notification Change");
    }
    return result;
  } catch (err) {
    throw new Error(`Could not update Notification Change: ${err.message}`);
  }
};
export const getOrganisations = async () => {
  try {
    const result = await get(`/api/v1/clients/organisation-index?category=all`);
    return result;
  } catch (err) {
    throw new Error(`Could not get Donation Organisations: ${err.message}`);
  }
};
export const getNotifications = async () => {
  try {
    const result = await get(`/api/v1/notifications/get-all`);
    return result;
  } catch (err) {
    throw new Error(`Could not get Donation Organisations: ${err.message}`);
  }
};
export const makeDonation = async (data) => {
  try {
    const result = await create("/api/v1/donations/create", data);
    return result;
  } catch (err) {
    throw new Error(`Could not get Donation Organisations: ${err.message}`);
  }
};
export const closeSubAccount = async (userId, accountId) => {
  try {
    const result = await updatePatch(
      `/api/v1/sub-accounts/delete-account/${userId}/${accountId}`
    );
    return result;
  } catch (err) {
    throw new Error(`Could not get Donation Organisations: ${err.message}`);
  }
};

export const getPayAddresses = async () => {
  try {
    const result = await get("/api/v1/pay-address/user-addresses");
    return result;
  } catch (err) {
    throw new Error(
      err?.response?.data?.message || "Could not get pay addresses"
    );
  }
};
export const createPayAddress = async (address, authId) => {
  try {
    const result = await create("/api/v1/pay-address/create", {
      authId: authId,
      name: address.name,
      lastname: address.lastname,
      payId: address.payId,
    });
    return result;
  } catch (err) {
    throw new Error(
      err?.response?.data?.message || "Could not create pay address"
    );
  }
};
export const addPayAddress = async (address) => {
  try {
    const result = await update(
      "/api/v1/pay-address/add-address",
      {},
      { name: address.name, lastname: address.lastname, payId: address.payId }
    );
    return result;
  } catch (err) {
    throw new Error(
      err?.response?.data?.message || "Could not add pay address"
    );
  }
};
export const updatePayAddress = async (address, address_id) => {
  try {
    const body = {
      name: address.name,
      lastname: address.lastname,
    };
    // Only include the field that has a value
    if (address.payId) body.payId = address.payId;
    if (address.email) body.email = address.email;
    if (address.cellphone) body.cellphone = address.cellphone;

    const result = await update(
      "/api/v1/pay-address/update",
      { addressId: address_id },
      body
    );
    return result;
  } catch (err) {
    throw new Error(
      err?.response?.data?.message || "Could not update pay address"
    );
  }
};
export const deletePayAddress = async (address_id) => {
  try {
    const result = await deleteResource("/api/v1/pay-address/delete", {
      addressId: address_id,
    });
    return result;
  } catch (err) {
    throw new Error(
      err?.response?.data?.message || "Could not delete pay address"
    );
  }
};

//Wallet Address Calls

export const getAddresses = async () => {
  try {
    const result = await get("/api/v1/address-book/user-addresses");
    return result;
  } catch (err) {
    throw new Error(
      err?.response?.data?.message || "Could not get wallet addresses"
    );
  }
};

export const createWalletAddress = async (address) => {
  try {
    const result = await create("/api/v1/address-book/create", {
      firstName: address.firstName,
      lastName: address.lastName,
      addressName: address.addressName,
      walletAddress: address.walletAddress,
      asset: address.asset,
      assetName: address.assetName,
      chain: address.chain,
      chainName: address.chainName,
      walletType: address.walletType,
      transferType: address.transferType,
      category: address.category,
      provider: address.provider,
      iban: address.iban,
      swiftCode: address.swiftCode,
      recipientBank: address.recipientBank,
    });
    return result;
  } catch (err) {
    throw err;
  }
};
export const deleteWalletAddress = async (address_id) => {
  try {
    const result = await deleteResource("/api/v1/address-book/delete", {
      addressId: address_id,
    });
    return result;
  } catch (err) {
    throw new Error(
      err?.response?.data?.message || "Could not delete wallet address"
    );
  }
};
export const updateWalletAddress = async (address) => {
  try {
    const result = await update(
      "/api/v1/address-book/update",
      { addressId: address.id },
      {
        firstName: address.firstName,
        lastName: address.lastName,
        addressName: address.addressName,
        walletAddress: address.walletAddress,
        asset: address.asset,
        assetName: address.assetName,
        chain: address.chain,
        chainName: address.chainName,
        walletType: address.walletType,
        transferType: address.transferType,
        category: address.category,
        provider: address.provider,
        iban: address.iban,
        swiftCode: address.swiftCode,
        recipientBank: address.recipientBank,
      }
    );
    return result;
  } catch (err) {
    throw err;
  }
};

export const setWalletCurrency = async (data, user_id) => {
  try {
    const result = await updatePatch(
      "/api/v1/settings/wallet-currency/" + user_id,
      {},
      { localCurrency: data }
    );
    if (!result) {
      //throw new Error("Could not update time frame");
    }
    return result;
  } catch (err) {
    //throw new Error(`Could not update time frame: ${err.message}`);
  }
};

export const setToggelZero = async (data, user_id) => {
  try {
    const result = await updatePatch(
      "/api/v1/settings/toggle-zero-balances/" + user_id
    );
    if (!result) {
      //throw new Error("Could not update time frame");
    }
    return result;
  } catch (err) {
    //throw new Error(`Could not update time frame: ${err.message}`);
  }
};

export const setShowBalances = async (user_id) => {
  try {
    const result = await updatePatch(
      "/api/v1/settings/show-balances-toggle/" + user_id
    );
    if (!result) {
      //throw new Error("Could not update time frame");
    }
    return result;
  } catch (err) {
    //throw new Error(`Could not update time frame: ${err.message}`);
  }
};

export const setZeroBalances = async (user_id) => {
  try {
    const result = await updatePatch(
      "/api/v1/settings/toggle-zero-balances/" + user_id
    );
    if (!result) {
      //throw new Error("Could not update time frame");
    }
    return result;
  } catch (err) {
    //throw new Error(`Could not update time frame: ${err.message}`);
  }
};

export const verify2FA = async (data) => {
  try {
    const result = await create("api/v1/auth/verify-code", data);

    return result;
  } catch (err) {
    //throw new Error(`Something went wrong: ${err.message}`);
  }
};

export const disable2FA = async (data) => {
  try {
    const result = await updatePatch("api/v1/settings/disable-twofa", {}, data);

    return result;
  } catch (err) {
    //throw new Error(`Something went wrong: ${err.message}`);
  }
};

export const setToggle2FaLogin = async (user_id) => {
  try {
    const result = await updatePatch(
      "/api/v1/settings/login-2fa-toggle/" + user_id
    );
    if (!result) {
      //throw new Error("Could not update time frame");
    }
    return result;
  } catch (err) {
    //throw new Error(`Could not update time frame: ${err.message}`);
  }
};

export const setAutoSignOut = async (user_id, data) => {
  try {
    const result = await updatePatch(
      "/api/v1/settings/sign-out-duration/" + user_id,
      {},
      { duration: data }
    );
    if (!result) {
      //throw new Error("Could not update time frame");
    }
    return result;
  } catch (err) {
    //throw new Error(`Could not update time frame: ${err.message}`);
  }
};

export const getSystemSettings = async () => {
  try {
    const result = await get("/api/v1/system-settings/get-all");
    return result;
  } catch (err) {
    throw new Error(`Could not get system settings: ${err.message}`);
  }
};

export const resolvePayId = async (payId) => {
  try {
    // Use existing pay/user-details endpoint to resolve PayID
    const result = await get(
      `/api/v1/pay/user-details?paymentId=${encodeURIComponent(payId)}&method=payid`
    );
    return result;
  } catch (err) {
    throw err;
  }
};

export const createPayIdBeneficiary = async (data) => {
  try {
    const result = await update("/api/v1/pay-address/add-address", {}, data);
    return result;
  } catch (err) {
    throw err;
  }
};
